import * as React from 'react'
import { cn } from '#app/shared/lib/misc.js'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'shadow' | 'border'
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'shadow', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-b-sm bg-white',
        variant === 'shadow'
          ? `shadow-car-card-shadow`
          : 'border border-gray-200',
        className,
      )}
      {...props}
    />
  ),
)
Card.displayName = 'Card'

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'text-2xl font-semibold leading-none tracking-tight',
      className,
    )}
    {...props}
  >
    {children}
  </h3>
))
CardTitle.displayName = 'CardTitle'

export { Card, CardTitle }
